export const REACTIVATION_STATE = Object.freeze({
  PENDING: "pending",
  ACTIVE: "active",
  REACTIVATION: "reactivation",
  UNAVAILABLE: "unavailable",
});

export const resolveSubscriptionReactivation = (subscriptionStatus = {}) => {
  if (subscriptionStatus.isLoading) {
    return {
      state: REACTIVATION_STATE.PENDING,
      isPending: true,
      isResolved: false,
      isReactivation: false,
      isUnavailable: false,
    };
  }

  if (subscriptionStatus.isEmpty || subscriptionStatus.hasError) {
    return {
      state: REACTIVATION_STATE.UNAVAILABLE,
      isPending: false,
      isResolved: false,
      isReactivation: false,
      isUnavailable: true,
    };
  }

  if (
    subscriptionStatus.isCanceled ||
    subscriptionStatus.isExpired ||
    subscriptionStatus.isInactive
  ) {
    return {
      state: REACTIVATION_STATE.REACTIVATION,
      isPending: false,
      isResolved: true,
      isReactivation: true,
      isUnavailable: false,
    };
  }

  if (
    subscriptionStatus.isActive === true ||
    Boolean(subscriptionStatus.currentTier)
  ) {
    return {
      state: REACTIVATION_STATE.ACTIVE,
      isPending: false,
      isResolved: true,
      isReactivation: false,
      isUnavailable: false,
    };
  }

  return {
    state: REACTIVATION_STATE.UNAVAILABLE,
    isPending: false,
    isResolved: false,
    isReactivation: false,
    isUnavailable: true,
  };
};
